import React , {useEffect,useRef} from 'react'
import lottie from 'lottie-web'
import style  from '../../styles/mystyle.module.css'
import { useTranslation } from 'next-i18next'
import * as config  from '../../next.config.js'
import {Customebtn} from './StyledComponent/HintDialog1.style'
import {useRouter} from 'next/router'
export default function NoData(props) {
    const router=useRouter()
    const lottieDiv=React.useRef()
    const {t}=useTranslation("common")
    React.useEffect(() => {
      
        let instance= lottie.loadAnimation({
            container:lottieDiv.current,
            
            loop:true,
            autoplay:true,
              renderer:"svg",
            path:`${config.basePath}/json/error.json`,
            rendererSettings: {
             className:style.svglottie,
                id:"imgSuccess"

            
            }
        })

  

        return()=>  instance.destroy()
    }, [])
    return (
        <div  className={style.SectionContainer}>
        <div  className={style.allcard}>
        <div className={style.animation} ref={lottieDiv}></div>
        <div className={style.FlexColumn}>
            {/* {console.log("router==========>",router)} */}
            {/* <p className={style.sizepricetext + " "  + " " + " " + style.marginZero} style={{fontWeight:"bolder"}}>{t("Sorry")}</p> */}
        
            {/* <p className={style.sizepricetext + " " + style.marginZero}>{props.text? props.text:t("Notfound")}</p> */}
        
            {/* router.push({ pathname: "/user-ms/login", query: { next: (`${constants.HakeemMedical}/${data.entityType[0].code}/${data.slug.length > 0 && data.slug.filter(i => i.active == true).length > 0 ? data.slug.filter(i => i.active == true)[0].url : data.id}/book`).replace('/[^a-zA-Z0-9-_]/g', '') } }) */}
<Customebtn onClick={()=>router.push({ pathname: "/user-ms/login", query:{next:router.asPath}},router.asPath,{locale:router.locale})} variant="contained">
    {t("Singin")}
</Customebtn>
  
        </div>
        </div>
        </div>
    )
}
